var _ellipse, _g, _path, _ellipse2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 49,
    viewBox: "0 0 125 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 24.5,
    rx: 23,
    ry: 24,
    fill: "url(#paint0_linear_222_644)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9677 29.9594C18.6395 29.9 20.777 28.0594 20.8958 25.2094C21.1333 26.3969 21.6677 27.4656 22.2614 28.3563C20.6583 29.6031 19.1145 30.1375 17.5708 30.1375C16.977 30.1375 16.502 30.0781 15.9677 29.9594Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6489 24.9719C38.6489 25.2094 38.4708 25.4469 38.2333 25.4469H37.6395V25.0312C37.7583 23.4875 37.402 22.4187 36.7489 21.4688L38.2333 21.8844C38.5302 22.0031 38.6489 22.1219 38.6489 22.5375V24.9719Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83325 22.5969C7.83325 22.1812 7.89263 22.0031 8.24888 21.9438L9.79263 21.4688C9.08013 22.4781 8.72388 23.8437 8.78325 25.0312V25.4469H8.24888C8.01138 25.4469 7.83325 25.2687 7.83325 24.9719V22.5969Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2363 21.35C14.0676 20.3406 15.1957 19.8062 16.6801 19.8062C19.4113 19.8062 21.5488 21.4687 22.6176 24.2L23.152 25.625C24.5176 29.1875 26.2395 30.9687 28.3176 31.6219C25.1113 31.1469 22.6176 29.2469 21.5488 26.1L21.0738 24.675C20.0645 21.7656 18.4613 20.4 15.9676 20.4C14.9582 20.4 13.9488 20.7562 13.2363 21.35Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8208 18.8562C35.0271 19.2719 37.2833 21.7062 37.2833 24.5562C37.2833 27.05 35.3833 29.1281 32.8302 29.3062C34.552 28.2375 35.2052 26.8125 35.2052 24.9125C35.2052 22.1219 33.8989 19.6875 31.8208 18.8562Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.477 18.6781C25.2302 19.1531 24.2208 19.925 23.2708 20.9344C22.0239 19.6875 21.252 19.2125 19.827 18.7375L26.477 18.6781Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5083 21.2312C25.1708 19.45 27.3083 18.5 29.1489 18.5C31.4646 18.5 33.7208 19.9844 34.4927 22.6562C33.4239 20.875 31.6427 20.3406 30.3958 20.3406C27.8427 20.3406 25.5864 22.4781 25.5864 25.15C24.9927 23.1906 24.1614 21.825 23.5083 21.2312Z",
    fill: "#000041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19885 25.0312C9.19885 21.1719 12.1676 18.5 16.502 18.5C20.4801 18.5 23.5676 20.6375 24.9332 24.3187L25.3489 25.4469C26.477 28.5344 28.3176 29.9594 30.9895 29.9594C33.0082 29.9594 35.3239 29.3063 36.5114 27.8813C35.502 30.1969 33.2457 31.5031 30.5145 31.5031C27.3676 31.5031 25.1114 29.425 23.7457 25.8625L23.152 24.2594C21.8457 21.1719 19.6489 19.3906 16.7395 19.3906C13.4739 19.3906 11.2176 21.7062 11.2176 24.9719C11.2176 28.2969 13.652 30.5531 17.3332 30.5531C18.5207 30.5531 19.5895 30.3156 20.5989 29.8406C19.4114 30.9688 17.7489 31.5625 15.9082 31.5625C12.0489 31.5625 9.19885 28.7719 9.19885 25.0312Z",
    fill: "#000041"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 0.5V48.5",
    stroke: "#DFDFDF",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.5,
    cy: 24.5,
    rx: 23,
    ry: 24,
    fill: "url(#paint1_linear_222_644)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.665 23.3779L107.885 31.0219C107.823 31.3034 107.77 31.5393 107.603 31.7848C107.449 31.9953 107.25 32.1649 107.022 32.2796C106.413 32.5887 105.619 32.5752 105.046 32.2233C104.779 32.0769 104.564 31.8453 104.432 31.5624C104.344 31.3716 104.309 31.1216 104.256 30.9217L104.088 30.2771C103.18 26.5615 102.174 22.8695 101.266 19.1539C101.241 19.0734 101.221 18.9916 101.204 18.909C101.096 18.4817 100.64 18.4772 100.534 18.8527C100.494 18.9973 100.456 19.1814 100.44 19.2586C99.7784 22.5469 99.0377 25.8307 98.3671 29.1185C98.3132 29.4 98.2592 29.6139 98.1028 29.8588C97.949 30.0697 97.7495 30.2395 97.5207 30.3543C96.9121 30.6628 96.1094 30.6493 95.5359 30.298C95.2745 30.1457 95.0623 29.9159 94.9263 29.6376C94.8028 29.3561 94.6706 28.6929 94.5913 28.3523C94.0621 26.1995 93.4973 24.1148 92.9508 21.962C92.8968 21.7441 92.7301 21.5944 92.448 21.5853C92.0595 21.5944 91.9624 21.944 91.9009 22.1939C91.8125 22.539 91.4424 24.0878 91.3539 24.3237C91.327 24.3901 91.2945 24.454 91.2568 24.5145C91.1033 24.7912 90.8925 25.0286 90.6396 25.2092C90.1897 25.5594 89.2106 25.8769 88.6112 25.6365C88.205 25.4727 88.0906 25.2047 88.0906 24.8596C88.1257 24.5218 88.4348 24.2105 88.9538 24.1469C89.0951 24.1283 89.3422 24.1604 89.483 23.9149C89.5164 23.8494 89.5402 23.779 89.5537 23.7061C89.5715 23.6289 89.5887 23.5608 89.6076 23.4882L89.9426 22.1708C90.0576 21.7075 90.1455 21.2262 90.4454 20.845C90.5929 20.6588 90.7688 20.4992 90.966 20.3727C92.1653 19.5913 94.0621 19.9049 94.6792 21.1079C94.8292 21.4035 94.9528 21.9524 95.0321 22.2902C95.4998 24.2161 95.8413 26.0914 96.3112 28.0218C96.3651 28.2628 96.5054 28.2988 96.664 28.2673C96.8582 28.2262 96.8226 28.1356 96.9197 27.5951L98.66 18.4344C98.7587 18.071 98.9684 17.7511 99.2572 17.5235C100.016 16.8969 101.224 16.7877 102.133 17.2741C102.688 17.6282 102.942 17.9007 103.094 18.5228C104.02 22.315 104.893 26.1623 105.819 29.9455C105.864 30.1859 106.014 30.218 106.172 30.1904C106.384 30.1499 106.384 29.7637 106.437 29.5182L107.885 22.633C107.964 22.2953 108.079 21.7385 108.229 21.4429C108.846 20.2303 110.743 19.8807 111.942 20.6441C112.139 20.7689 112.315 20.927 112.463 21.1119C112.701 21.4024 112.78 21.6568 112.86 21.9974C112.895 22.1472 112.939 22.2879 112.974 22.4287L113.301 23.7415C113.318 23.8142 113.336 23.8823 113.355 23.9594C113.373 24.0294 113.396 24.0977 113.425 24.1638C113.566 24.4092 113.813 24.3726 113.954 24.389C114.475 24.4481 114.783 24.7526 114.828 25.0932C114.828 25.4384 114.704 25.7063 114.298 25.8814C113.698 26.1314 112.719 25.8223 112.27 25.4817C112.016 25.305 111.804 25.0706 111.65 24.796C111.613 24.7362 111.584 24.6722 111.562 24.6051C111.464 24.3693 111.076 22.7659 110.997 22.4253C110.926 22.1348 110.83 21.8939 110.468 21.8849C110.053 21.8984 109.928 22.2789 109.833 22.673C109.771 22.8982 109.718 23.1313 109.665 23.3812L109.665 23.3779ZM116.042 24.3501C116.5 24.3636 116.889 24.7132 116.827 25.1631C116.773 25.6134 116.474 25.985 116.042 25.985C115.601 25.985 115.363 25.6624 115.248 25.1631C115.134 24.6637 115.583 24.336 116.042 24.3501ZM86.9701 24.1638C87.4379 24.1728 87.8257 24.5269 87.7642 24.9767C87.7027 25.4265 87.4114 25.7987 86.9701 25.7987C86.5386 25.7987 86.3001 25.4761 86.1852 24.9767C86.0703 24.4774 86.5116 24.1503 86.9701 24.1638Z",
    fill: "url(#paint2_linear_222_644)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_644",
    x1: 40.3056,
    y1: 75.2359,
    x2: 46.5,
    y2: -29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_644",
    x1: 124.526,
    y1: 24.6395,
    x2: 79.6226,
    y2: 24.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#FEE6EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDECE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_644",
    x1: 116.851,
    y1: 24.7805,
    x2: 86.9151,
    y2: 24.7805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#DA0557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5434"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.875,
    height: 13.0625,
    fill: "white",
    transform: "translate(7.83325 18.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandsLogo);
export default __webpack_public_path__ + "static/media/brands_logo.50927ae0fad69bd05bbfdbb4994549ef.svg";
export { ForwardRef as ReactComponent };